import { IEvent } from "~app/common/services/cqs/event.service";

export class TplTabOpenMessage implements IEvent {
    tabId: string;
    $type: string;

    static readonly EVENTNAME = "TplTabOpen";
    constructor(tabId: string) {
        this.$type = `features.transport.transportplanera.events.${TplTabOpenMessage.EVENTNAME},${TplTabOpenMessage.EVENTNAME}`;
        this.tabId = tabId;
    }
}
